/* Copyright (c) 2023 Xperi. All Rights Reserved. */

import { PostSignInError } from './PostSignInError';

export class GuideError extends PostSignInError {
    TAG: string = 'GuideError';

    constructor(message: string, code: string) {
        super(code, message);
    }

    protected type: string = '';

    public getType(): string {
        return this.type;
    }
}
